import { render } from "./PropertyFilesPopup.vue?vue&type=template&id=bd36ac4c"
import script from "./PropertyFilesPopup.vue?vue&type=script&lang=js"
export * from "./PropertyFilesPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__